import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const articleImages: Record<string, string> = {
  'best-free-movie-sites-2025': 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20posters%20displayed%20on%20a%20warm%20lit%20wooden%20shelf%2C%20cozy%20home%20theater%20vibe%20with%20soft%20golden%20ambient%20light%2C%20rich%20dark%20wood%20textures%2C%20film%20noir%20aesthetic%20with%20warm%20amber%20and%20deep%20crimson%20accents%2C%20elegant%20cinematic%20atmosphere&width=800&height=450&seq=article-01&orientation=landscape',
  'how-to-choose-streaming-site': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20living%20room%20with%20large%20flat%20screen%20TV%20displaying%20vibrant%20movie%20scene%2C%20warm%20evening%20ambient%20lighting%20from%20floor%20lamp%2C%20comfortable%20sofa%20with%20throw%20pillows%2C%20cozy%20home%20cinema%20setup%20with%20wooden%20furniture&width=800&height=450&seq=article-02&orientation=landscape',
  'top-korean-drama-sites': 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20drama%20scene%20aesthetic%20with%20warm%20romantic%20lighting%2C%20cherry%20blossom%20petals%20in%20soft%20focus%2C%20traditional%20hanok%20house%20background%20with%20modern%20touches%2C%20cinematic%20composition%20with%20rich%20golden%20and%20rose%20tones&width=800&height=450&seq=article-03&orientation=landscape',
  'anime-streaming-guide': 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20art%20style%20illustration%20with%20colorful%20characters%20and%20dynamic%20action%20poses%2C%20Japanese%20manga%20inspired%20backdrop%20with%20cherry%20blossoms%2C%20warm%20sunset%20color%20palette%20with%20golden%20and%20coral%20hues%2C%20cinematic%20lighting&width=800&height=450&seq=article-04&orientation=landscape',
  'documentary-must-watch': 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20majestic%20mountain%20landscape%20at%20golden%20hour%2C%20wildlife%20in%20natural%20habitat%2C%20professional%20cinematography%20aesthetic%20with%20warm%20earth%20tones%2C%20dramatic%20clouds%20and%20atmospheric%20light&width=800&height=450&seq=article-05&orientation=landscape',
  'variety-show-2025': 'https://readdy.ai/api/search-image?query=Lively%20TV%20variety%20show%20stage%20with%20colorful%20lighting%20and%20dynamic%20set%20design%2C%20entertaining%20performance%20atmosphere%20with%20warm%20spotlights%2C%20audience%20silhouettes%20in%20background%2C%20vibrant%20and%20energetic%20composition&width=800&height=450&seq=article-06&orientation=landscape',
  'mobile-movie-watching-tips': 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20movie%20playback%20on%20screen%20in%20cozy%20bedroom%20with%20warm%20bedside%20lamp%20lighting%2C%20headphones%20and%20popcorn%20nearby%2C%20comfortable%20evening%20atmosphere%20with%20soft%20golden%20glow&width=800&height=450&seq=article-07&orientation=landscape',
  'classic-movie-collection': 'https://readdy.ai/api/search-image?query=Vintage%20film%20collection%20display%20with%20classic%20movie%20posters%20in%20ornate%20gold%20frames%2C%20old%20film%20projector%20on%20wooden%20table%2C%20warm%20nostalgic%20lighting%20with%20sepia%20tones%2C%20antique%20cinema%20memorabilia%20aesthetic&width=800&height=450&seq=article-08&orientation=landscape',
  'free-vs-vip-comparison': 'https://readdy.ai/api/search-image?query=Split%20comparison%20scene%20showing%20two%20contrasting%20viewing%20experiences%2C%20one%20side%20premium%20home%20theater%20with%20luxurious%20seating%2C%20other%20side%20cozy%20laptop%20setup%2C%20warm%20ambient%20lighting%20throughout%2C%20balanced%20composition&width=800&height=450&seq=article-09&orientation=landscape',
};

export default function FeaturedSection() {
  const featuredArticles = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
              精选推荐文章
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              最新、最实用的看片网站推荐与观影指南
            </p>
          </div>
          <Link
            to="/category/latest-movies"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {article.category === 'latest-movies' ? '最新电影' :
                     article.category === 'hot-series' ? '热门剧集' :
                     article.category === 'variety-shows' ? '综艺节目' :
                     article.category === 'documentaries' ? '纪录片' : '动漫动画'}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-star-fill"></i> {article.rating}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  {article.tags.slice(0, 3).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}